<ng-container *ngIf="team">
  <mtg-statistic-filters-widget
    *ngIf="isBrowser"
    [league]="league"
    [seasonId]="filters.tournament_season_id"
    [tournamentId]="filters.tournament_id"
    [roundId]="filters.tournament_round_id"
    [teamId]="team.id"
    [additionalFiltersVisible]="false"
    (filters)="setFilters($event)"
  ></mtg-statistic-filters-widget>
  <mtg-tournament-team-card
    [team]="team"
    [tournamentTeam]="tournamentTeam"
    [usersCount]="usersCount"
    [teamStatistic]="commonStatistic$ | async"
    [actualTournamentTeam]="actualTournamentTeam"
  ></mtg-tournament-team-card>
  <mtg-tournament-team-uniform
    *ngIf="league.sport.isHockey()"
    [tournamentTeam]="tournamentTeam"
  ></mtg-tournament-team-uniform>
  <mtg-tournament-team-games></mtg-tournament-team-games>
  <mtg-tournament-team-disqualifications
    *ngIf="league.sport.isHockey()"
  ></mtg-tournament-team-disqualifications>
  <mtg-tournament-team-statistic
    [team]="team"
  ></mtg-tournament-team-statistic>
  <mtg-tournament-team-photos [leagueId]="league.id" [teamId]="team.id"></mtg-tournament-team-photos>
</ng-container>
